export const colors = {
  primary: "#FF6600",
  white: "#FFFFFF",
  black: "#000000",
  grey: "#F5F5F5",
  greyMid: "#C4C4C4",
  greyDark: "#787878",
  red: "#FF0000",
  blue: "#437FA3",
}

export const breakPoints = {
  tablet: "1020px",
  mobile: "425px",
}
